import { useEffect, useState } from 'react';

/** Tiny History-API router (no dependency). */
export function navigate(to: string, replace = false) {
  if (replace) history.replaceState(null, '', to);
  else history.pushState(null, '', to);
  window.dispatchEvent(new Event('scs:navigate'));
}

export function useLocation(): { path: string; query: URLSearchParams } {
  const read = () => ({ path: location.pathname, query: new URLSearchParams(location.search) });
  const [loc, setLoc] = useState(read);
  useEffect(() => {
    const on = () => setLoc(read());
    window.addEventListener('popstate', on);
    window.addEventListener('scs:navigate', on);
    return () => {
      window.removeEventListener('popstate', on);
      window.removeEventListener('scs:navigate', on);
    };
  }, []);
  return loc;
}
